import { RootState } from '@reducers';

export const selectCarPolicyClaim = (state: RootState) => state.userDashboardRouteReducer.policyClaim.carPolicyClaim;
